module.exports = __webpack_public_path__ + "static/Lato-Regular-6d4e78225df0cfd5fe1bf3e8547fefe4.ttf";